import { isTemplateCustomType, useDownloader } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { InlineButton } from '@platform/ui'
import { CertificateRecord } from '@/api/models/certificate-record'
import { useShareCertificate } from '@/hooks/useShareCertificate'
import { captureException } from '@/utils/sentryUtils'
import styles from './CoverActions.module.scss'
import { ExpireDate } from './ExpireDate/ExpireDate'

type Props = {
  certificateRecord: CertificateRecord
}

export const CoverActions = ({ certificateRecord }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleShareCertificate = useShareCertificate(certificateRecord)

  const downloader = useDownloader()
  const handleDownloadCertificate = async () => {
    if (!certificateRecord?.certificatePdfUrl) {
      captureException(new Error('No certificate pdf url'))
      return
    }
    await downloader(certificateRecord.certificatePdfUrl, `${certificateRecord.certificateNumber}.pdf`)
  }

  const isCustomType = isTemplateCustomType(certificateRecord.certificateTemplate)

  const handleViewCertificate = () => {
    if (isCustomType) {
      navigate(`/courses/${certificateRecord.objectiveId}/certificate/${certificateRecord.certificateNumber}`)
    } else if (certificateRecord.externalUrl) {
      window.open(certificateRecord.externalUrl, '_blank', 'noopener')
    } else {
      captureException(new Error('No external url'))
    }
  }

  return (
    <div className={styles.certificateCoverDetails}>
      <ExpireDate expirationDate={certificateRecord.expirationDate} />
      <div className={styles.certificateCoverActions}>
        <InlineButton
          text={t('courseDetails.certificates.view')}
          onClick={handleViewCertificate}
          iconBeforeText="EyeOpenedMediumStroke"
          size="medium"
        />
        {isCustomType && (
          <InlineButton
            text={t('courseDetails.certificates.download')}
            onClick={handleDownloadCertificate}
            iconBeforeText="DownloadMediumStroke"
            size="medium"
          />
        )}
        {isCustomType && (
          <InlineButton
            text={t('courseDetails.certificates.shareLink')}
            onClick={handleShareCertificate}
            iconBeforeText="ShareMediumStroke"
            size="medium"
          />
        )}
      </div>
    </div>
  )
}
